(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.iwInit) return;
    root.dataset.iwInit = '1';

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-iw-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-iw-dot]'));
    var track = root.querySelector('[data-iw-track]');
    var live = root.querySelector('[data-iw-live]');
    var toggle = root.querySelector('[data-iw-toggle]');
    var isSlide = root.getAttribute('data-transition') === 'slide';
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var n = slides.length;
    if (n < 2) return;

    var interval = Math.max(2, parseInt(root.getAttribute('data-interval'), 10) || 6) * 1000;
    var wantsAuto = root.getAttribute('data-autoplay') === 'true' && !reduce;
    root.style.setProperty('--iw-ss-dur', (interval / 1000) + 's');

    var current = 0;
    var timer = null;
    var paused = false;
    var userPaused = false;

    function show(i, announce) {
      i = (i % n + n) % n;
      slides.forEach(function (s, idx) {
        var on = idx === i;
        s.classList.toggle('is-active', on);
        if (on) { s.removeAttribute('aria-hidden'); s.removeAttribute('inert'); }
        else { s.setAttribute('aria-hidden', 'true'); s.setAttribute('inert', ''); }
      });
      dots.forEach(function (d, idx) {
        var on = idx === i;
        d.classList.toggle('is-active', on);
        d.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      if (isSlide && track) track.style.transform = 'translateX(' + (-i * 100) + '%)';
      current = i;
      if (announce && live) live.textContent = 'Slide ' + (i + 1) + ' von ' + n;
      restartProgress();
    }

    function next() { show(current + 1, true); }
    function prev() { show(current - 1, true); }

    function restartProgress() {
      // retrigger the CSS progress animation on the active dot
      if (!root.classList.contains('is-playing')) return;
      var fill = root.querySelector('.iw-ss__dot.is-active .iw-ss__dot-fill');
      if (fill) { fill.style.animation = 'none'; void fill.offsetWidth; fill.style.animation = ''; }
    }

    function play() {
      if (!wantsAuto || userPaused) return;
      stop();
      root.classList.add('is-playing');
      root.classList.remove('is-paused');
      timer = window.setInterval(function () { if (!paused) next(); }, interval);
      restartProgress();
    }
    function stop() {
      if (timer) { window.clearInterval(timer); timer = null; }
      root.classList.remove('is-playing');
    }

    // Controls
    var prevBtn = root.querySelector('[data-iw-prev]');
    var nextBtn = root.querySelector('[data-iw-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); if (wantsAuto && !userPaused) play(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); if (wantsAuto && !userPaused) play(); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        show(parseInt(d.getAttribute('data-goto'), 10) || 0, true);
        if (wantsAuto && !userPaused) play();
      });
    });

    if (toggle) {
      toggle.addEventListener('click', function () {
        userPaused = !userPaused;
        toggle.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
        toggle.setAttribute('aria-label', userPaused ? 'Automatisches Abspielen starten' : 'Automatisches Abspielen pausieren');
        if (userPaused) { stop(); root.classList.add('is-paused'); }
        else { root.classList.remove('is-paused'); play(); }
      });
    }

    // Keyboard (when focus is inside the carousel)
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); prev(); play(); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); next(); play(); }
    });

    // Pause on hover / focus
    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; });
    root.addEventListener('focusin', function () { paused = true; });
    root.addEventListener('focusout', function () { if (!root.contains(document.activeElement)) paused = false; });

    // Pause when tab hidden
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else play();
    });

    // Touch swipe
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; paused = true; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 45) { dx < 0 ? next() : prev(); }
      x0 = null; paused = false; play();
    }, { passive: true });

    // Pause autoplay while off-screen
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { en.isIntersecting ? play() : stop(); });
      }, { threshold: 0.35 }).observe(root);
    } else {
      play();
    }

    show(0, false);
    if (wantsAuto) play();
  }

  function boot() {
    document.querySelectorAll('[data-iw-slideshow]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Theme editor
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-iw-slideshow]');
    if (el) { el.removeAttribute('data-iw-init'); init(el); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Lokalisierte Foto-Navigations-Labels (einmalig aus dem Section-Root gelesen — scope-unabhängig)
  var LB_PREV = 'Vorheriges Foto', LB_NEXT = 'Nächstes Foto';
  var _lbRoot = document.querySelector('.iw-testi[data-lb-prev]');
  if (_lbRoot) { LB_PREV = _lbRoot.getAttribute('data-lb-prev') || LB_PREV; LB_NEXT = _lbRoot.getAttribute('data-lb-next') || LB_NEXT; }

  function fmt(n) { return (Math.round(n * 10) / 10).toString().replace('.', ','); }

  function buildStars(rating, tpl) {
    var wrap = document.createElement('span');
    wrap.className = 'iw-testi__stars';
    wrap.setAttribute('role', 'img');
    wrap.setAttribute('aria-label', rating + ' von 5 Sternen');
    for (var i = 1; i <= 5; i++) {
      var star;
      if (tpl) {
        star = tpl.cloneNode(true);
        star.className = 'iw-testi__star' + (i > rating ? ' is-empty' : '');
      } else {
        star = document.createElement('span');
        star.className = 'iw-testi__star' + (i > rating ? ' is-empty' : '');
        star.textContent = '★';
      }
      wrap.appendChild(star);
    }
    return wrap;
  }

  function metaText(r, verifiedLabel) {
    if (r.verified) return verifiedLabel;
    var parts = [];
    if (r.city) parts.push(r.city);
    if (r.country) parts.push(r.country);
    return parts.join(', ');
  }

  // Shopify-CDN-Bilder auf Kartengröße verkleinern → schnelles Laden, kein leeres Aufblitzen.
  function optimizeImg(url, w) {
    if (!url || url.indexOf('cdn.shopify.com') === -1) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  // Reiche Bewertungs-Lightbox: Foto-Galerie + Sterne + Text + Autor + "Zum Produkt"-CTA.
  function openLightbox(r, opts) {
    var media = (r.media || []).filter(function (m) { return (m.type === 'video' ? (m.poster || m.url) : m.url); });
    if (!media.length) return;
    var idx = 0, dots = null;

    var ov = document.createElement('div');
    ov.className = 'iw-testi__lb';
    ov.setAttribute('role', 'dialog');
    ov.setAttribute('aria-modal', 'true');
    ov.setAttribute('aria-label', 'Kundenbewertung von ' + (r.author || 'Kunde'));

    var panel = document.createElement('div');
    panel.className = 'iw-testi__lb-panel';

    var stage = document.createElement('div');
    stage.className = 'iw-testi__lb-stage';
    var big = document.createElement('img');
    big.className = 'iw-testi__lb-img';
    big.alt = 'Kundenfoto von ' + (r.author || 'Kunde');
    function showIdx(i) {
      idx = (i + media.length) % media.length;
      var m = media[idx];
      big.src = optimizeImg(m.type === 'video' ? (m.poster || m.url) : m.url, 1600);
      if (dots) [].forEach.call(dots.children, function (d, di) { d.className = di === idx ? 'is-active' : ''; });
    }
    stage.appendChild(big);

    if (media.length > 1) {
      var prev = document.createElement('button');
      prev.type = 'button'; prev.className = 'iw-testi__lb-nav iw-testi__lb-prev';
      prev.setAttribute('aria-label', LB_PREV);
      prev.addEventListener('click', function (e) { e.stopPropagation(); showIdx(idx - 1); });
      var next = document.createElement('button');
      next.type = 'button'; next.className = 'iw-testi__lb-nav iw-testi__lb-next';
      next.setAttribute('aria-label', LB_NEXT);
      next.addEventListener('click', function (e) { e.stopPropagation(); showIdx(idx + 1); });
      stage.appendChild(prev); stage.appendChild(next);
      dots = document.createElement('div');
      dots.className = 'iw-testi__lb-dots';
      media.forEach(function (_, di) {
        var d = document.createElement('button');
        d.type = 'button'; d.setAttribute('aria-label', 'Foto ' + (di + 1));
        d.addEventListener('click', function (e) { e.stopPropagation(); showIdx(di); });
        dots.appendChild(d);
      });
      stage.appendChild(dots);
    }

    var detail = document.createElement('div');
    detail.className = 'iw-testi__lb-detail';
    detail.appendChild(buildStars(r.rating || 5, opts.starTpl));
    var txt = (r.body && r.body.trim()) || (r.title && r.title.trim()) || '';
    if (txt) {
      var bq = document.createElement('blockquote');
      bq.className = 'iw-testi__lb-quote'; bq.textContent = txt;
      detail.appendChild(bq);
    }
    var who = document.createElement('div');
    who.className = 'iw-testi__lb-author';
    if (r.author) { var nm = document.createElement('span'); nm.className = 'iw-testi__name'; nm.textContent = r.author; who.appendChild(nm); }
    var meta = metaText(r, opts.verifiedLabel);
    if (meta) {
      var mt = document.createElement('span'); mt.className = 'iw-testi__meta';
      if (opts.checkTpl) mt.appendChild(opts.checkTpl.cloneNode(true));
      mt.appendChild(document.createTextNode(meta));
      who.appendChild(mt);
    }
    detail.appendChild(who);
    if (r.productHandle) {
      var cta = document.createElement('a');
      cta.className = 'iw-testi__lb-cta';
      cta.href = '/products/' + r.productHandle;
      cta.textContent = 'Zum Produkt ansehen';
      detail.appendChild(cta);
    }

    var close = document.createElement('button');
    close.type = 'button'; close.className = 'iw-testi__lb-close';
    close.setAttribute('aria-label', 'Schließen'); close.innerHTML = '&times;';

    panel.appendChild(stage); panel.appendChild(detail); panel.appendChild(close);
    ov.appendChild(panel);

    function onKey(e) {
      if (e.key === 'Escape') closeLb();
      else if (e.key === 'ArrowLeft' && media.length > 1) showIdx(idx - 1);
      else if (e.key === 'ArrowRight' && media.length > 1) showIdx(idx + 1);
    }
    function closeLb() { ov.remove(); document.removeEventListener('keydown', onKey); document.documentElement.style.overflow = ''; }
    ov.addEventListener('click', function (e) { if (e.target === ov) closeLb(); });
    close.addEventListener('click', closeLb);
    document.addEventListener('keydown', onKey);
    document.documentElement.style.overflow = 'hidden';
    showIdx(0);
    document.body.appendChild(ov);
    close.focus();
  }

  function buildCard(r, opts) {
    var li = document.createElement('li');
    li.className = 'iw-testi__card';

    // Kundenfoto ganz oben — echte Produktfotos schaffen Vertrauen und steigern die Kaufbereitschaft.
    if (r.media && r.media.length) {
      var mi = r.media[0];
      var imgUrl = mi.type === 'video' ? (mi.poster || mi.url) : mi.url;
      if (imgUrl) {
        li.className = 'iw-testi__card iw-testi__card--photo';
        var figBtn = document.createElement('button');
        figBtn.type = 'button';
        figBtn.className = 'iw-testi__photo';
        figBtn.setAttribute('aria-label', 'Kundenfoto vergrößern');
        var pimg = document.createElement('img');
        pimg.src = optimizeImg(imgUrl, 900); pimg.loading = 'lazy'; pimg.decoding = 'async';
        pimg.alt = 'Kundenfoto' + (r.author ? ' von ' + r.author : '');
        figBtn.appendChild(pimg);
        if (mi.type === 'video') {
          var pl = document.createElement('span');
          pl.className = 'iw-testi__play';
          pl.setAttribute('aria-hidden', 'true');
          figBtn.appendChild(pl);
        }
        if (r.media.length > 1) {
          var more = document.createElement('span');
          more.className = 'iw-testi__more';
          more.setAttribute('aria-hidden', 'true');
          more.textContent = '+' + (r.media.length - 1);
          figBtn.appendChild(more);
        }
        figBtn.addEventListener('click', function () { openLightbox(r, opts); });
        li.appendChild(figBtn);
      }
    } else if (r.productHandle) {
      // Kein Kundenfoto → Hauptbild des gekauften Produkts zeigen (visuell vollständige Wand, Link zum Produkt).
      li.className = 'iw-testi__card iw-testi__card--product';
      var pa = document.createElement('a');
      pa.className = 'iw-testi__photo iw-testi__photo--product';
      pa.href = '/products/' + r.productHandle;
      pa.setAttribute('aria-label', (r.productTitle || 'Produkt') + ' ansehen');
      var prodImg = document.createElement('img');
      prodImg.loading = 'lazy'; prodImg.decoding = 'async';
      prodImg.alt = r.productTitle || 'Produkt';
      pa.appendChild(prodImg);
      li.appendChild(pa);
      fetch('/products/' + r.productHandle + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (pd) {
          if (pd && pd.featured_image) {
            var u = pd.featured_image;
            if (u.indexOf('//') === 0) u = 'https:' + u;
            prodImg.src = optimizeImg(u, 900);
          } else { pa.remove(); li.className = 'iw-testi__card'; }
        })
        .catch(function () { pa.remove(); li.className = 'iw-testi__card'; });
    }

    li.appendChild(buildStars(r.rating || 5, opts.starTpl));

    var text = (r.body && r.body.trim()) || (r.title && r.title.trim()) || '';
    if (text) {
      var bq = document.createElement('blockquote');
      bq.className = 'iw-testi__quote';
      bq.textContent = text;
      li.appendChild(bq);
    }

    var author = document.createElement('div');
    author.className = 'iw-testi__author';
    if (opts.showAvatar && r.author) {
      var av = document.createElement('span');
      av.className = 'iw-testi__avatar';
      av.setAttribute('aria-hidden', 'true');
      av.textContent = r.author.trim().charAt(0).toUpperCase();
      author.appendChild(av);
    }
    var body = document.createElement('span');
    body.className = 'iw-testi__author-body';
    if (r.author) {
      var name = document.createElement('span');
      name.className = 'iw-testi__name';
      name.textContent = r.author;
      body.appendChild(name);
    }
    var meta = metaText(r, opts.verifiedLabel);
    if (meta) {
      var m = document.createElement('span');
      m.className = 'iw-testi__meta';
      if (opts.checkTpl) m.appendChild(opts.checkTpl.cloneNode(true));
      m.appendChild(document.createTextNode(meta));
      body.appendChild(m);
    }
    author.appendChild(body);
    li.appendChild(author);
    return li;
  }

  function hydrate(root) {
    var proxy = root.getAttribute('data-proxy');
    if (!proxy) return;
    var grid = root.querySelector('.iw-testi__grid');
    if (!grid) return;
    var limit = parseInt(root.getAttribute('data-limit') || '6', 10) || 6;
    var locale = root.getAttribute('data-locale') || 'de';
    var opts = {
      showAvatar: root.getAttribute('data-avatar') === '1',
      verifiedLabel: root.getAttribute('data-verified-label') || 'Verifizierter Kauf',
      starTpl: root.querySelector('.iw-testi__card .iw-testi__star'),
      checkTpl: root.querySelector('.iw-testi__card .iw-testi__meta svg')
    };

    fetch(proxy + '/featured?limit=' + limit + '&locale=' + encodeURIComponent(locale), { headers: { 'Accept': 'application/json' } })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        if (!data || !data.ok || !data.reviews || !data.reviews.length) return; // SSR-Fallback behalten
        var frag = document.createDocumentFragment();
        // Fotobewertungen zuerst — sie ziehen den Blick an und überzeugen am stärksten.
        var ordered = data.reviews.slice().sort(function (a, b) {
          return ((b.media && b.media.length) ? 1 : 0) - ((a.media && a.media.length) ? 1 : 0);
        });
        ordered.forEach(function (r) { frag.appendChild(buildCard(r, opts)); });
        grid.replaceChildren(frag);
        // Zusammenfassung (Bewertung + Anzahl) bleibt vom Theme-Customizer gesteuert —
        // der Händler bestimmt die Social-Proof-Zahlen (z. B. "4,9" und "50+ zufriedene Kund:innen").
        // Nicht mit der reinen App-Bewertungszahl überschreiben.
      })
      .catch(function () { /* SSR-Fallback behalten */ });
  }

  function init() { document.querySelectorAll('[data-iw-reviews-app]').forEach(hydrate); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

  } catch(e) { console.error(e); }
})();
})();
